import { apiRankUpdate, apiRankMine } from "@/lib/ranking-api";

export class RankManager {
  static async handleEvent(gameId: string, event: any, user: any) {
    const { type, score } = event;

    if (type === "update") {
      // 랭킹 업데이트 요청
      return await RankManager.updateRank(gameId, score, user);
    }
    if (type === "mine") {
      // 나의 랭킹 요청
      return await RankManager.getMyRank(gameId, user);
    }
  }

  static async updateRank(gameId: string, score: number, user: any) {
    try {
      const result = await apiRankUpdate(
        {
          gameId,
          userId: user._id,
          username: user.name,
          score,
        },
        user.token,
      );
      return {
        type: "update",
        success: true,
        data: result,
      };
    } catch (error) {
      return {
        type: "update",
        success: false,
        message: "랭킹 업데이트 실패",
      };
    }
  }

  static async getMyRank(gameId: string, user: any) {
    try {
      console.log("[RankManager] getMyRank", gameId, user);
      const result = await apiRankMine(
        {
          gameId,
          userId: user._id,
        },
        user.token,
      );
      return {
        type: "mine",
        success: true,
        data: result,
      };
    } catch (error) {
      return {
        type: "mine",
        success: false,
        message: "나의 랭킹 가져오기 실패",
      };
    }
  }
}
